import { Controller } from "@hotwired/stimulus"

// Fills a hidden field with a server-issued value. Contact-form bots that
// post without running JavaScript never set it, and the server discards the
// submission. Humans and real browsers are unaffected.
export default class extends Controller {
  static targets = ["field"]
  static values = { token: String }

  connect() {
    this.fieldTarget.value = this.tokenValue
  }
}
